import React from "react";
import MatchWrapper from "bracket-system/core/match-wrapper";
import { getPreviousMatches } from "bracket-system/core/match-functions";
import { calculatePositionOfMatchLowerBracket } from "./calculate-match-position";
import ConnectorsLower from "./lower-connectors";
import LowerRoundHeader from "bracket-system/components/lower-round-header";
import { Match, Participant } from "bracket-system/types";

const LowerBracket = ({
	columns,
	calculatedStyles,
	gameHeight,
	gameWidth,
	onMatchClick,
	onPartyClick,
	matchComponent,
	upperBracketHeight,
	onLowerClick,
	onColumnClick,
	customHeaderNames,
	lockedColumns,
	hideSeriesScore,
	isQualifierRound,
}) => {
	const { canvasPadding, columnWidth, rowHeight, roundHeader } =
		calculatedStyles;

	if (isQualifierRound && columns?.length) {
		const lastColumn = columns[columns.length - 1];
		customHeaderNames.push("Qualified");
		columns = [...columns];
		columns.push([...lastColumn]);
	}

	return (
		// @ts-ignore
		<g style={{ pointerEvents: "bounding-box" }} onClick={onLowerClick}>
			{columns.map((matchesColumn, columnIndex) => {
				const isQualifierColumn =
					isQualifierRound && columnIndex === columns.length - 1;
				const isFirstColumn = columnIndex === 0;
				const colPos = calculatePositionOfMatchLowerBracket(
					columns,
					0,
					columnIndex,
					{
						canvasPadding,
						columnWidth,
						rowHeight,
					},
					isQualifierRound
				);

				return (
					<React.Fragment key={columnIndex}>
						{roundHeader.isShown && (
							<LowerRoundHeader
								x={colPos.x}
								roundHeader={roundHeader}
								canvasPadding={canvasPadding}
								width={calculatedStyles.width}
								numOfRounds={columns.length}
								columnIndex={columnIndex}
								upperBracketHeight={upperBracketHeight}
								onClick={(event) => {
									if (onColumnClick) {
										onColumnClick("LB", columnIndex);
										event.stopPropagation();
									}
								}}
								customHeaderText={
									customHeaderNames && customHeaderNames[columnIndex]
								}
								isQualifierRound={isQualifierRound}
							/>
						)}
						{matchesColumn.map((match, rowIndex) => {
							const { x, y } = calculatePositionOfMatchLowerBracket(
								columns,
								rowIndex,
								columnIndex,
								{
									canvasPadding,
									columnWidth,
									rowHeight,
									offsetY: upperBracketHeight,
								},
								isQualifierRound
							);

							const isUpperSeedingRound =
								isFirstColumn ||
								columns[columnIndex].length === columns[columnIndex - 1].length;

							const previousBottomPosition = isUpperSeedingRound
								? rowIndex
								: (rowIndex + 1) * 2 - 1;
							const { previousTopMatch, previousBottomMatch } =
								getPreviousMatches(
									columnIndex,
									columns,
									previousBottomPosition
								);
							return (
								<React.Fragment key={match.id}>
									{columnIndex !== 0 && (
										<ConnectorsLower
											{...{
												columns,
												bracketSnippet: {
													currentMatch: match,
													previousTopMatch:
														!isUpperSeedingRound && previousTopMatch,
													previousBottomMatch,
												},
												rowIndex,
												columnIndex,
												gameHeight,
												gameWidth,
												style: calculatedStyles,
												offsetY: upperBracketHeight,
												isQualifierRound,
												isQualifierColumn,
											}}
										/>
									)}
									<g>
										<MatchWrapper
											x={x}
											y={
												y +
												(roundHeader.isShown
													? roundHeader.height + roundHeader.marginBottom
													: 0) +
												(isQualifierColumn ? 19 : 0)
											}
											rowIndex={rowIndex}
											columnIndex={columnIndex}
											match={match}
											previousBottomMatch={previousBottomMatch}
											topText={match.startTime}
											bottomText={match.name}
											teams={match.participants}
											onMatchClick={onMatchClick}
											onPartyClick={(
												e: MouseEvent,
												match: Match,
												isTop: boolean,
												party: Participant,
												partyWon: boolean
											) => {
												if (
													onPartyClick &&
													!lockedColumns.includes(columnIndex)
												) {
													onPartyClick(e, match, isTop, party, partyWon);
												}
											}}
											style={calculatedStyles}
											matchComponent={matchComponent}
											hideSeriesScore={hideSeriesScore}
											isQualifierColumn={isQualifierColumn}
										/>
									</g>
								</React.Fragment>
							);
						})}
					</React.Fragment>
				);
			})}
		</g>
	);
};

export default LowerBracket;
